module.exports = __webpack_public_path__ + "img/UI_RMYX_BG_01_1_dfed96928.png";